import { RSAA, RSAAction } from 'redux-api-middleware';
import { CMS_API } from 'store/api';

import * as types from './homePageActionTypes';

export const fetchHomePage = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    api: CMS_API,
    endpoint: 'homepage',
    method: 'GET',
    types: [types.FETCH_HOME_PAGE_REQUEST, types.FETCH_HOME_PAGE_SUCCESS, types.FETCH_HOME_PAGE_FAILURE],
  },
});
